import React, { Component, Fragment } from 'react';
import { withNamespaces } from "react-i18next";
import { withRouter } from "react-router-dom";
import { Basemap, Fullscreen, Locate, SimpleMarker } from "../../../libs/arcgis";
import mapApi from "../../../apiV2/mapApi";
import queryString from 'query-string';
import { Button, Card, CardBody, CardFooter, CardHeader, Col, Row } from "reactstrap";
import { Form, FormEventsEmitter } from "react-components-form";
import { MultiSelectField, TextField } from "../../../shared/Form";
import AdsFinder from "../../../shared/AdsFinder/AdsFinder";
import i18n from "i18next";
import { loadModules } from "esri-loader";
import Geolocation from "./components/Geolocation";
import GraphicsCleaner from "./components/GraphicsCleaner";
import { connect } from "react-redux";
import { addMessage } from "../../../store/actions";
import Spinner from "../../../shared/Spinner/Spinner";
import { prepareServiceIntensityLayers } from "../../../libs/arcgis/layers/utils";

const mapDispatchToProps = { addMessage };

const formEventsEmitter = new FormEventsEmitter();

let queryResult;

class Map extends Component {

    constructor(props) {
        super(props);

        this.state = {
            mapLayerGroups: null,

            filter: {},

            filterObjectTypes: [],
            filterObjectElements: [],
            filterObjectElementsPlaceholder: props.t('messages.selectOneOrMoreObjectTypes'),
            filterCityParts: [],
            filterAgeGroups: [],
            filterIsObjectElementsDisabled: true,
            filterInputedAddress: '',
            filterCoordinates: null,
            filterCoordinatesRadius: 500,
            filterIsPlaygroundSelected: false,
            filterFindingMyCoordinates: false,
        };

        this.filterFormRef = React.createRef();
        this.mapRef = React.createRef();
    }

    async componentDidMount() {
        let form = this.filterFormRef.current;
        let filterApiResult = null;
        await mapApi.getSearchFiltersPublic().then(result => {
            if (result.success) {
                filterApiResult = result;
                this.setState({
                    filterObjectTypes: result.filters.objectTypes.map(ot => ({
                        value: ot.id,
                        label: ot.name,
                        isPlayground: ot.isPlayground,
                        elements: ot.elements
                    })),
                    filterCityParts: result.filters.cityParts.map(cp => ({ value: cp.id, label: cp.name })),
                    filterAgeGroups: result.filters.ageGroups.map(ag => ({ value: ag, label: this.props.t('ages.' + ag) })),
                }, () => {
                    if (form) {
                        formEventsEmitter.emit('submit');
                    }
                });
            }
        });

        queryResult = queryString.parse(window.location.search)
        for (const [key, value] of Object.entries(queryResult)) {
            if (value !== "") {
                if (value.includes("{"))
                    form.setModel(key, JSON.parse(value));
                else
                    form.setModel(key, value);

                if (key == "address" && value.includes("{")) {
                    this.handleFilterSelectAddress(JSON.parse(value))
                }
                if (key == "objectTypes") {
                    let selectedTypes = [];
                    JSON.parse(value).forEach((element, index) => {
                        selectedTypes.push(filterApiResult.filters.objectTypes.filter((x) => { return x.id == element.value })[0])
                    });
                    this.handleOnTypesChange(selectedTypes.map(ot => ({
                        value: ot.id,
                        label: ot.name,
                        isPlayground: ot.isPlayground,
                        elements: ot.elements
                    })), null, "objectTypes")
                }
                if (key == "radius") {
                    this.handleFilterChangeCoordinatesRadius(parseInt(value));
                }
            }
        }
        formEventsEmitter.emit('submit');
    }

    mapGoToPoint = (coordinates) => {
        loadModules([
            'esri/geometry/Point',
            'esri/geometry/SpatialReference'
        ]).then(([Point, SpatialReference]) => {
            let map = this.mapRef.current,
                view = (map) ? map.state.view : null;
            if (view && view.ready) {
                let spatialReference = (coordinates.wkid) ? new SpatialReference(coordinates.wkid) : view.spatialReference,
                    point = new Point({
                        x: coordinates.x,
                        y: coordinates.y,
                        spatialReference,
                        geodesic: (coordinates.wkid && (coordinates.wkid === 3857 || coordinates.wkid === 4326)),
                    });
                view.goTo({ target: point, scale: 2000 }, { duration: 1000 });
            }
        });
    };

    handleFilterSelectAddress = (value) => {
        let points = value.value.split('|'),
            x = parseFloat(points[0]),
            y = parseFloat(points[1]),
            form = this.filterFormRef.current;
        if (x && y) {
            this.setState({
                filterCoordinates: null, // force to redraw Location marker
            }, () => {
                this.setState({
                    filterCoordinates: { x, y, wkid: 3301 },
                }, () => {
                    this.mapGoToPoint(this.state.filterCoordinates);
                });
            });
        } else {
            this.props.addMessage({ type: "error", message: i18n.t('common:messages.addressNoCoordinates') });
        }
        form.setModel('address', value.label);

        queryResult['address'] = JSON.stringify(value)
        let searchString = queryString.stringify(queryResult);
        this.props.history.push({
            search: searchString
        })
    };

    handleFilterChangeCoordinatesRadius = (radius) => {
        const coordinates = this.state.filterCoordinates;
        this.setState({
            filterCoordinates: null, // force to redraw Location marker
            filterCoordinatesRadius: radius,
        }, () => {
            this.setState({
                filterCoordinates: coordinates,
            });
            queryResult['radius'] = radius
            let searchString = queryString.stringify(queryResult);
            this.props.history.push({
                search: searchString
            })
        });
    };

    handleOnTypesChange = (values, e, name) => {
        if (values.length > 0) {
            let elements = [];
            values.forEach(value => {
                if (value.elements) {
                    value.elements.forEach(e => {
                        if (elements.indexOf(e) < 0) {
                            elements.push(e);
                        }
                    });
                }
            });
            this.setState({
                filterObjectElements: elements.map(e => ({ value: e.id, label: e.name })),
                filterIsObjectElementsDisabled: false,
                filterIsPlaygroundSelected: values.some(v => v.isPlayground),
            });
            if (!values.some(v => v.isPlayground)) {
                let form = this.filterFormRef.current;
                if (form) {
                    form.setModel('ageGroups', []);
                }
            }
        } else {
            this.setState({
                filterObjectElements: [],
                filterIsObjectElementsDisabled: true,
                filterIsPlaygroundSelected: false,
            }, () => {
                let form = this.filterFormRef.current;
                if (form) {
                    form.setModel('objectElements', []);
                    form.setModel('ageGroups', []);
                }
            });
        }
        if (values.length > 0) {
            queryResult[name] = JSON.stringify(values.map((x) => ({ label: x.label, value: x.value })))
            let searchString = queryString.stringify(queryResult);
            this.props.history.push({
                search: searchString
            })
        } else {
            delete queryResult[name];
            delete queryResult["ageGroups"];
            let searchString = queryString.stringify(queryResult);
            this.props.history.push({
                search: searchString
            })
        }
    };

    handleFilterFindMyCoordinates = () => {
        this.setState({
            filterCoordinates: null,
            filterFindingMyCoordinates: true,
        });
    };

    handleFilterFoundMyCoordinates = (coordinates) => {
        if (coordinates) {
            this.setState({
                filterCoordinates: {
                    x: coordinates.longitude,
                    y: coordinates.latitude,
                    wkid: 4326,
                },
                filterFindingMyCoordinates: false,
            });
        }
    };

    handleFilterClearCoordinates = () => {
        this.setState({
            filterCoordinates: null,
            filterInputedAddress: '',
            filterFindingMyCoordinates: false,
        }, () => {
            let form = this.filterFormRef.current;
            if (form) {
                form.setModel('address', '');
            }
            delete queryResult['address'];
            delete queryResult['radius'];
            let searchString = queryString.stringify(queryResult);
            this.props.history.push({
                search: searchString
            })
        });
    };

    handleFilterClear = () => {
        let form = this.filterFormRef.current;
        if (form) {
            form.setModel('location', '');
            form.setModel('objectTypes', []);
            form.setModel('objectElements', []);
            form.setModel('objectName', '');
            form.setModel('ageGroups', []);
            form.setModel('cityParts', []);
            form.setModel('address', '');

            this.setState({
                filterCoordinates: null,
                filterCoordinatesRadius: 500,
                filterIsObjectElementsDisabled: true,
            });
        }
    };

    handleFilterSubmit = (model) => {
        if (model.objectTypes) {
            if (model.objectTypes.length > 0) model.ot = model.objectTypes.map(ot => ot.value);
            delete model.objectTypes;
        }
        if (model.objectElements) {
            if (model.objectElements.length > 0) model.oe = model.objectElements.map(oe => oe.value);
            delete model.objectElements;
        }
        if (model.ageGroups) {
            if (model.ageGroups.length > 0) model.ag = model.ageGroups.map(ag => ag.value);
            delete model.ageGroups;
        }
        if (model.cityParts) {
            if (model.cityParts.length > 0) model.cp = model.cityParts.map(cp => cp.value);
            delete model.cityParts;
        }
        if (model.address !== undefined) delete model.address;
        if (model.location !== undefined) {
            if (model.location.trim() !== '') model.l = model.location;
            delete model.location;
        }
        if (model.objectName !== undefined) {
            if (model.objectName.trim() !== '') model.on = model.objectName;
            delete model.objectName;
        }
        if (this.state.filterCoordinates && this.state.filterCoordinatesRadius) {
            model.c = this.state.filterCoordinates;
            model.r = this.state.filterCoordinatesRadius;
        }

        this.setState({
            filter: { of: model }, // wrap model to "of" (objects filter)
        }, () => {
            this.loadLayerGroups();
        });
    };

    loadLayerGroups = () => {
        this.setState({
            mapLayerGroups: null,
        }, () => {
            mapApi.getLayerGroups(this.state.filter).then(result => {
                if (result.success) {
                    for (let group of result.groups) {
                        group.subLayers = prepareServiceIntensityLayers(group.subLayers, true);
                    }
                    this.setState({
                        mapLayerGroups: result.groups,
                    });
                }
            });
        });
    };
    inputChange = (e) => {
        if (e.currentTarget.value !== "") {
            queryResult[e.currentTarget.name] = e.currentTarget.value
            let searchString = queryString.stringify(queryResult);
            this.props.history.push({
                search: searchString
            })
        } else {
            delete queryResult[e.currentTarget.name];
            let searchString = queryString.stringify(queryResult);
            this.props.history.push({
                search: searchString
            })
        }
    }
    handeSelectFieldQuery = (val, e, name) => {
        if (val.length > 0) {
            queryResult[name] = JSON.stringify(val)
            let searchString = queryString.stringify(queryResult);
            this.props.history.push({
                search: searchString
            })
        } else {
            delete queryResult[name];
            let searchString = queryString.stringify(queryResult);
            this.props.history.push({
                search: searchString
            })
        }
    }

    render() {
        const { t } = this.props;
        return (
            <Fragment>
                <div className="content-wrapper">
                    <div className="content-heading">
                        <div className="container">
                            <div className="row">
                                <div className="col-6">
                                    {t('form.map')}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid">
                        <Row>
                            <Col lg={3} md={12} sm={12} xs={12}>
                                <Card className='card-default'>
                                    <Form
                                        ref={this.filterFormRef}
                                        onSubmit={this.handleFilterSubmit}
                                        onError={console.error}
                                        eventsEmitter={formEventsEmitter}
                                    >
                                        <CardHeader>
                                            <h4 className='p-0 m-0'>{t('fields.objectsFilter')}</h4>
                                        </CardHeader>
                                        <CardBody>
                                            <TextField
                                                type='text'
                                                name='objectName'
                                                label={t('fields.objectName')}
                                                fieldAttributes={{
                                                    'autoComplete': 'off',
                                                }}
                                                callbacks={{ onBlur: this.inputChange }}
                                            />

                                            <MultiSelectField
                                                label={t('fields.objectType')}
                                                wrapperClassName='mt-3'
                                                isMulti={true}
                                                name="objectTypes"
                                                placeholder={t('fields.select')}
                                                options={this.state.filterObjectTypes}
                                                onChanged={this.handleOnTypesChange}

                                            />

                                            <MultiSelectField
                                                label={t('sidebar.objectsElement')}
                                                wrapperClassName='mt-3'
                                                isMulti={true}
                                                name="objectElements"
                                                placeholder={this.state.filterIsObjectElementsDisabled
                                                    ? t('messages.selectOneOrMoreObjectTypes')
                                                    : t('fields.select')
                                                }
                                                options={this.state.filterObjectElements}
                                                disabled={this.state.filterIsObjectElementsDisabled}
                                                onChanged={this.handeSelectFieldQuery}

                                            />

                                            {this.state.filterIsPlaygroundSelected &&
                                                <MultiSelectField
                                                    label={t('fields.ageGroups')}
                                                    wrapperClassName='mt-3'
                                                    isMulti={true}
                                                    name="ageGroups"
                                                    placeholder={t('fields.select')}
                                                    options={this.state.filterAgeGroups}
                                                    onChanged={this.handeSelectFieldQuery}
                                                />
                                            }

                                            <div className={'mt-3'}>
                                                <TextField
                                                    type='text'
                                                    name='location'
                                                    label={t('fields.addressNotADS')}
                                                    fieldAttributes={{
                                                        'autoComplete': 'off',
                                                    }}
                                                    callbacks={{ onBlur: this.inputChange }}
                                                />
                                            </div>

                                            <MultiSelectField
                                                label={t('fields.cityPart')}
                                                wrapperClassName='mt-3'
                                                isMulti={true}
                                                name="cityParts"
                                                placeholder={t('fields.select')}
                                                options={this.state.filterCityParts}
                                                onChanged={this.handeSelectFieldQuery}
                                            />

                                            <hr style={{ marginTop: '25px' }} />

                                            <Row className='mt-3'>
                                                <Col xs={12}>
                                                    <TextField
                                                        type='text'
                                                        name='address'
                                                        label={t('fields.myAddressOnMap')}
                                                        onChanged={(val) => this.setState({ filterInputedAddress: val.trim() })}
                                                        fieldAttributes={{
                                                            'autoComplete': 'off',
                                                        }}
                                                        style={{
                                                            position: "absolute",
                                                            top: "20px"
                                                        }}
                                                    />
                                                    <div style={{ height: 0, position: 'relative', top: -17 + 'px' }}>
                                                        <AdsFinder
                                                            value={this.state.filterInputedAddress}
                                                            inputValue={(value) => this.handleFilterSelectAddress(value)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col xs={6} className='text-left'>
                                                    <Button
                                                        type='button'
                                                        color='secondary'
                                                        onClick={this.handleFilterFindMyCoordinates}
                                                    >
                                                        <i className='fas fa-map-marker-alt text-info mr-1' /> {t('fields.findMyLocation')}
                                                    </Button>
                                                    {(this.state.filterFindingMyCoordinates && !this.state.filterCoordinates) &&
                                                        <div>
                                                            <Geolocation update={this.handleFilterFoundMyCoordinates} />
                                                            <p className="text-left text-danger">{t('messages.enableYourGeolocation')}</p>
                                                        </div>
                                                    }
                                                </Col>
                                                <Col xs={6} className='text-right'>
                                                    {this.state.filterCoordinates &&
                                                        <Button
                                                            type='button'
                                                            color='danger'
                                                            outline={true}
                                                            onClick={this.handleFilterClearCoordinates}
                                                        >
                                                            <i className='fas fa-remove mr-1' /> {t('form.cancel')}
                                                        </Button>
                                                    }
                                                </Col>
                                            </Row>

                                            <Row className='mt-3'>
                                                <Col xs={12}>
                                                    {t('fields.radiusM')}
                                                </Col>
                                                <Col xs={12} className='mt-1'>
                                                    {[100, 200, 500, 1000, 2000].map(radius => (
                                                        <Button
                                                            key={radius}
                                                            className='mr-1 mb-1'
                                                            color={radius === this.state.filterCoordinatesRadius
                                                                ? 'info'
                                                                : 'secondary'}
                                                            onClick={() => {
                                                                this.handleFilterChangeCoordinatesRadius(radius)
                                                            }}
                                                            disabled={this.state.filterCoordinates === null}
                                                        >
                                                            {radius}
                                                        </Button>
                                                    ))}
                                                </Col>
                                            </Row>
                                        </CardBody>
                                        <CardFooter className='bg-white text-right'>
                                            <Button
                                                type='button'
                                                color='secondary'
                                                onClick={this.handleFilterClear}
                                            >
                                                {t('fields.clearFilters')}
                                            </Button>
                                            <Button
                                                type='submit'
                                                color='primary'
                                                className='ml-2'
                                            >
                                                {t('fields.search')}
                                            </Button>
                                        </CardFooter>
                                    </Form>
                                </Card>
                            </Col>
                            <Col lg={9} md={12} sm={12} xs={12}>
                                <Card className='card-default p-0'>
                                    {this.state.mapLayerGroups === null
                                        ? <div className='baseMapFull'><Spinner /></div>
                                        : <Basemap
                                            ref={this.mapRef}
                                            className={'baseMapFull'}
                                            rememberLayerListState={false}
                                            customGeoJSONLayers={this.state.mapLayerGroups}
                                            popupDockEnabled={true}
                                            //Load all layers automatically after filter by object type
                                            autoLoadCustomLayersByNames={this.state.filter.of && Object.keys(this.state.filter.of).length > 0
                                                ? ['objects']
                                                : null
                                            }
                                        >
                                            <Fullscreen />
                                            <Locate />

                                            {this.state.filterCoordinates
                                                ? <SimpleMarker
                                                    x={this.state.filterCoordinates.x}
                                                    y={this.state.filterCoordinates.y}
                                                    wkid={this.state.filterCoordinates.wkid}
                                                    radius={true}
                                                    radiusM={this.state.filterCoordinatesRadius}
                                                />
                                                : <GraphicsCleaner />
                                            }
                                        </Basemap>
                                    }
                                </Card>
                            </Col>
                        </Row>


                    </div>
                </div>
            </Fragment>
        );
    }

}
const MapItem = connect(null, mapDispatchToProps)(Map);

export default withRouter(withNamespaces('common')(MapItem));
